import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  name: string;
  shortName: string;
  description: string;
  badge?: string;
  price: string;
  priceNum: number;
  oldPrice: string;
  savings?: string;
  url: string;
  featured?: boolean;
}
const options: PricingOption[] = [{
  id: 'primaria',
  emoji: '📘',
  name: 'PRIMARIA',
  shortName: 'Primaria',
  description: '6 tomos + 120 clases + bonos',
  price: '$16.990',
  priceNum: 16990,
  oldPrice: '$49.900',
  url: 'https://www.profepack.com/cart/48097184284928:1'
}, {
  id: 'completo',
  emoji: '🏆',
  name: 'PACK COMPLETO',
  shortName: 'Pack Completo',
  description: '12 tomos + 240 clases + bonos',
  badge: 'AHORRÁS $7.990',
  price: '$27.990',
  priceNum: 27990,
  oldPrice: '$99.980',
  savings: '72% OFF',
  url: 'https://www.profepack.com/cart/48110061093120:1',
  featured: true
}, {
  id: 'secundaria',
  emoji: '📗',
  name: 'SECUNDARIA',
  shortName: 'Secundaria',
  description: '6 tomos + 120 clases + bonos',
  price: '$18.990',
  priceNum: 18990,
  oldPrice: '$49.990',
  url: 'https://www.profepack.com/cart/48110059782400:1'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" aria-label="Precios y ofertas" className="bg-brand-card py-20 md:py-28 px-4 border-t border-brand-border" data-id="element-190">
      <div className="max-w-lg mx-auto" data-id="element-191">
        <div className="text-center mb-10" data-id="element-192">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3" data-id="element-193">
            Elegí tu <span className="text-brand-accent" data-id="element-194">PROFEPACK:</span>
          </h2>
          <p className="text-white/60 text-sm md:text-base" data-id="element-195">
            Todas las opciones incluyen los 6 bonos estratégicos
          </p>
        </div>
        <div className="flex flex-col gap-3" data-id="element-196">
          {options.map(option => {
          const isSelected = selected === option.id;
          return <button key={option.id} onClick={() => setSelected(option.id)} aria-pressed={isSelected} className={`w-full text-left rounded-2xl p-4 md:p-5 border-2 ${isSelected ? 'border-brand-accent bg-brand-accent/5' : 'border-brand-border bg-brand-dark hover:border-white/20'} ${option.featured && !isSelected ? 'border-brand-accent/30' : ''}`} data-id="element-197">
                <div className="flex items-center gap-4" data-id="element-198">
                  <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-accent bg-brand-accent' : 'border-white/30 bg-transparent'}`} data-id="element-199">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-brand-dark" data-id="element-200" />}
                  </div>
                  <div className="flex-grow min-w-0" data-id="element-201">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-202">
                      <span className="text-lg" aria-hidden="true" data-id="element-203">
                        {option.emoji}
                      </span>
                      <span className={`font-black text-base md:text-lg ${isSelected ? 'text-white' : 'text-white/80'}`} data-id="element-204">
                        {option.name}
                      </span>
                      {option.featured && <span className="bg-brand-accent text-brand-dark text-[10px] md:text-xs font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-205">
                          ⭐ Más elegido
                        </span>}
                      {option.badge && isSelected && <span className="bg-brand-accent/20 text-brand-accent text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-206">
                          {option.badge}
                        </span>}
                    </div>
                    <p className={`text-xs md:text-sm mt-0.5 ${isSelected ? 'text-white/70' : 'text-white/50'}`} data-id="element-207">
                      {option.description}
                    </p>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-208">
                    <div className={`text-xs line-through ${isSelected ? 'text-white/60' : 'text-white/60'}`} data-id="element-209">
                      {option.oldPrice}
                    </div>
                    <div className={`text-xl md:text-2xl font-black ${isSelected ? 'text-brand-accent' : 'text-white/70'}`} data-id="element-210">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
          <button onClick={() => window.open(selectedOption.url, '_blank')} aria-label={`Comprar ${selectedOption.name} por ${selectedOption.price} ARS`} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-lg md:text-xl py-5 md:py-6 rounded-2xl transition-colors flex items-center justify-center gap-2 mt-1 active:scale-[0.98]" data-id="element-211">
            SÍ, QUIERO {selectedOption.shortName.toUpperCase()} →
          </button>
        </div>
        <p className="text-xs text-center text-white/50 italic mt-3 mb-8" data-id="element-212">
          {selected === 'completo' ? 'La opción más elegida por docentes que enseñan en los dos niveles' : 'Podés sumar el otro nivel cuando quieras'}
        </p>
        <div className="bg-brand-dark rounded-2xl p-5 border border-brand-border mb-8" data-id="element-213">
          <p className="text-xs font-bold text-white/50 uppercase tracking-widest mb-3" data-id="element-214">
            {selectedOption.name} incluye:
          </p>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-215">
            {(selected === 'completo' ? ['12 Tomos completos', '+240 clases con secuencia', 'Primaria + Secundaria', 'Rúbricas incluidas', '6 Bonos estratégicos', 'Acceso inmediato PDF'] : ['6 Tomos completos', '+120 clases con secuencia', 'Planificaciones listas', 'Rúbricas por año', '6 Bonos estratégicos', 'Acceso inmediato PDF']).map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-216">
                <span className="text-brand-accent text-sm" aria-hidden="true" data-id="element-217">
                  ✓
                </span>
                <span className="text-white/80 text-xs md:text-sm font-medium" data-id="element-218">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-white/60 font-medium text-xs" data-id="element-219">
          <span data-id="element-220">🔒 Pago seguro</span>
          <span data-id="element-221">⚡ Acceso en 5 min</span>
          <span data-id="element-222">🛡️ Garantía 7 días</span>
          <span data-id="element-223">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}